import { Link } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export interface ICompareToastContentProps {
  text: string;
  comparisonUrl?: string;
}

export function CompareToastContent({ text, comparisonUrl }: ICompareToastContentProps) {
  return (
    <div className={style['container']}>
      <span>{text}</span>
      {comparisonUrl && (
        <span className={style['link']}>
          <Link href={comparisonUrl} color="current_color" fontSize="M" fontWeight="bold" inline>
            Посмотреть
          </Link>
        </span>
      )}
    </div>
  );
}
